import clsx from 'clsx'
import Image from 'next/image'

import AiButton from 'components/ai-bolit/landing/ai-button/ai-button'
import SwiperSimple from 'components/parts/swiper-simple/swiper-simple'
import usePCWindow from 'hooks/usePCWindow'

import { ScreenSize } from 'constants/media-constanst'
import { imgDesktop, imgLogo, imgMobile, points, swiperProps } from './data'

import styles from './ai-landing-header.module.scss'
import commnomStyle from '../landing-common.module.scss'
import { A_LOG_REG_HASH, originAIBOLIT } from 'utils/analytics/other/registration/registration'

const AiLangingHeader = () => {
  const isBigPc = usePCWindow(ScreenSize.big)

  return (
    <div className={clsx(commnomStyle.section, styles.wrapper)}>
      <div className={styles.left}>
        {isBigPc ? (
          <Image className={styles.doctorPC} {...imgDesktop} />
        ) : (
          <Image className={styles.doctorMob} {...imgMobile} />
        )}
        <div className={styles.titleHelper}>
          <Image className={styles.logo} {...imgLogo} />
          <h1 className={styles.title}>AI Bolit</h1>
        </div>
        <h2 className={styles.subtitle}>Ваш умный помощник в мире клинических рекомендаций</h2>
        <div onClick={() => sessionStorage.setItem(A_LOG_REG_HASH, originAIBOLIT.AIBOLITTRY)}>
          <AiButton>Попробовать</AiButton>
        </div>
      </div>

      <div className={styles.right}>
        <SwiperSimple
          id={'ai-landing-header'}
          disableNav
          swiperProps={swiperProps}
          swiperMod={styles.swiperMod}
        >
          {points.map((itemCard, index) => {
            return (
              <div key={index} className={styles.card}>
                <Image className={styles.icon} {...itemCard.imgData} />
                <div>
                  <div className={styles.cardTitle}>{itemCard.title}</div>
                  <div className={styles.cardSubtitle}>{itemCard.subtitle}</div>
                </div>
              </div>
            )
          })}
        </SwiperSimple>
      </div>
    </div>
  )
}

export default AiLangingHeader
